import { Tooltip } from '@/components/ui';

/**
 * Kopftext einer Spalte mit gleichlautendem Kurzhinweis — Port von
 * `IwmSharedColumnsHeader.razor`.
 */
export interface HeaderTooltipProps {
  label: string;
}

export function HeaderTooltip(props: HeaderTooltipProps) {
  return (
    <Tooltip content={props.label}>
      <span className="e-headertext">{props.label}</span>
    </Tooltip>
  );
}

export default HeaderTooltip;
